import {CreateEtsyDraftListingRequest} from '@coolcolduk/etsy';
import {fileToBase64Object, mapPromiseFnSeries} from '@coolcolduk/util';
import getAxios from '../../util/axios/getAxios';

/**
 *
 * @param token
 * @param shopRecordId
 * @param newListing
 * @param sku
 * @param oldListingIdOrVideo
 * @param images
 * @param attachments
 * @returns success or failure
 */
export default async function createDraftListingHelper(
  token: string,
  shopRecordId: string,
  newListing: CreateEtsyDraftListingRequest,
  sku?: string,
  oldListingIdOrVideo?: number | File,
  images?: File[],
  attachments?: File[],
): Promise<boolean> {
  const imgs = await mapPromiseFnSeries(images || [], (i) => fileToBase64Object(i));
  const att = await mapPromiseFnSeries(attachments || [], (i) => fileToBase64Object(i));
  const data = {
    shopRecordId,
    newListing,
    sku,
    oldListingIdOrVideo:
      oldListingIdOrVideo instanceof File ? fileToBase64Object(oldListingIdOrVideo) : oldListingIdOrVideo,
    images: imgs,
    attachments: att,
  };

  const response = await getAxios('etsy', {
    token,
    // contentType: `multipart/form-data`,
  }).post<boolean>('createDraftListingHelper', data);
  return response.data;
}
